import script from "./payroll-deduction-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-deduction-modal.vue?vue&type=script&setup=true&lang=js"

import "./payroll-deduction-modal.vue?vue&type=style&index=0&id=636e634e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-636e634e"]])

export default __exports__